<template>
<div class="wph-textile-preview wph-pb-8">
  <div class="wph-relative md:wph-px-10">
    <div ref="slider" class="wph-textile-preview__gallery wph-pb-10 wph-relative wph-overflow-x-hidden">
      <div class="swiper-wrapper">
        <div v-for="(slide, index) in product.model.slides" :key="index" class="swiper-slide">
          <div class="wph-textile-preview__image wph-bg-cover"
               :style="{
               backgroundImage: `url(${slide.image})`,
               backgroundPosition: 'center',
               backgroundRepeat: 'no-repeat',
             }"
          >
          </div>
        </div>
      </div>
    </div>
    <div class="wph-swiper-nav-next wph--mt-6 wph-mr-2 wph-hidden md:wph-block" ref="slider-button-next">
      <div class="wph-swiper-nav-next__arrow"></div>
    </div>
    <div class="wph-swiper-nav-prev wph--mt-6 wph-ml-2 wph-hidden md:wph-block" ref="slider-button-prev">
      <div class="wph-swiper-nav-prev__arrow"></div>
    </div>
  </div>

  <div ref="slider-thumbs" class="wph-textile-preview__thumbs wph-mx-auto">
    <div class="swiper-wrapper">
      <div v-for="(slide, index) in product.model.slides" :key="index" class="swiper-slide wph-bg-cover"
           :style="{
             backgroundImage: `url(${slide.thumb})`,
             backgroundPosition: 'center',
             backgroundRepeat: 'no-repeat',
           }"
      ></div>
    </div>
  </div>
</div>
</template>

<script>
import { Swiper, Navigation, Thumbs } from 'swiper/dist/js/swiper.esm.js'
Swiper.use([Navigation, Thumbs])

export default {
  name: "TextilePreview",
  props: {
    product: { type: Object, required: true },
    color: { type: String, default: '' },
  },
  watch: {
    color: {
      handler() {
        this.$nextTick(() => {
          this.slideTo(this.slideIndex)
          this.transitionSpeed = 400
        })
      },
      immediate: true,
    },
  },
  data() {
    return {
      slider: null,
      sliderThumbs: null,
      transitionSpeed: 0,
    }
  },
  computed: {
    slideIndex() {
      const slide = this.product.model.slides.filter(slide => {
        return slide.color === this.color
      }, this)[0]
      const index = this.product.model.slides.indexOf(slide)
      return index > -1 ? index : 0
    },
  },
  methods: {
    resetSliders() {
      this.slider.update()
      this.sliderThumbs.update()
      this.slideToDefault()
    },
    slideTo(index) {
      this.slider.slideTo(index, this.transitionSpeed)
      this.sliderThumbs.slideTo(index, this.transitionSpeed)
    },
  },
  mounted() {
    const _this = this
    this.sliderThumbs = new Swiper(this.$refs['slider-thumbs'], {
      slidesPerView: 'auto',
      spaceBetween: 12,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
    })

    this.slider = new Swiper(this.$refs.slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      thumbs: {
        swiper: _this.sliderThumbs,
      },
      navigation: {
        nextEl: this.$refs['slider-button-next'],
        prevEl: this.$refs['slider-button-prev'],
      },
    })

    this.$emit('slider-ready')
  },
  updated() {
    this.resetSliders()
  },
  beforeDestroy() {
    this.slider.destroy()
    this.sliderThumbs.destroy()
  },
}
</script>

<style scoped>
</style>